import { FormControl } from 'baseui/form-control'
import SDDatePicker from '@/shared/components/SDComponents/SDDatePicker'
import { SIZE } from 'baseui/button'
import pickedDayAsIso from '@/shared/tools/pickedDayAsIso'

interface ByCreationDateProps {
  label: string
  onDateChangeHandler: (date: string) => void
}

const ByCreationDate = ({ label, onDateChangeHandler }: ByCreationDateProps) => {
  return (
    <FormControl label={label}>
      <SDDatePicker
        size={SIZE.compact}
        formatString='dd/MM/yyyy'
        onChange={({ date }: { date: unknown }) => {
          onDateChangeHandler(pickedDayAsIso(date))
        }}
      />
    </FormControl>
  )
}

export default ByCreationDate
